var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TheFoundation"},[(_vm.text)?_c('GridRow'):_vm._e(),_c('GridRow',[_c('TheFoundationText',{attrs:{"text":_vm.text}}),_vm._l((_vm.pillars),function(pillar,index){return _c('TheFoundationPillar',{key:pillar.name,attrs:{"index":index + 1,"content":pillar,"illu":_vm.illus[index]}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }